import React from 'react'

import Layout from '../src/components/layout'
import { Hero, ButtonNew } from '../src/storybook'
import { getMicroCopy } from '../src/utils/microcopy'
import { renderRichTextLine } from '../src/utils/text'
import Image from 'next/image'
import { BUTTON_VARIANT } from '../src/storybook/ButtonNew/ButtonNew'
import { useMicroCopyData } from '@/src/context/MicroCopyContext'
import { getMarketHeader } from '@/build-helpers/market'

export async function getStaticProps({ locale: slugPrefix }) {
  let language = slugPrefix?.split('-')[0] || 'en'
  let locale = slugPrefix
  let pageContext
  if (language === 'default') {
    language = 'en'
    locale = 'en'
    pageContext = await getMarketHeader('en', 'en')
  } else {
    pageContext = await getMarketHeader(language, locale)
  }

  if (!pageContext) {
    language = 'en'
    locale = 'en'
    pageContext = await getMarketHeader('en', 'en')
  }

  // Final fallback - if still null, provide empty structure
  if (!pageContext) {
    pageContext = { header: null, market: null, footer: null }
  }

  return {
    props: {
      locale: language,
      slugPrefix: locale,
      page: {},
      header: pageContext?.header,
      market: pageContext?.market,
      footer: pageContext?.footer,
      siteMetadata: {
        siteName: '404'
      },
      metaTags: {
        nofollow: true,
        noindex: true,
        noarchive: true,
        nosnippet: true,
        title: '404',
        description: '404'
      }
    }
  }
}

const NotFoundPage = (data) => {
  const microCopyData = useMicroCopyData()

  const metaTags = data.metaTags
  const locale = data.locale
  const slugPrefix = data.slugPrefix

  return (
    <Layout
      seoData={{
        marketsMetaTags: {},
        metaTags: metaTags,
        metaImage: null,
        alternate: []
      }}
      slugPrefix={slugPrefix}
    >
      <section className="l-section l-section--no-padding-bottom">
        <div className="u-text-align:center u-margin-top:40">
          <Image
            src={'/images/404.svg'}
            width={300}
            height={200}
            style={{
              objectFit: 'contain'
            }}
            alt="Not Found Illustration"
            priority
          />
        </div>
        <div className="u-text-align:center u-margin-top:24 u-margin-bottom:64">
          <Hero
            noVerticalPadding
            title={getMicroCopy({
              key: 'title404',
              data: microCopyData[locale],
              fallback: "We couldn't find the page you're looking for"
            })}
            content={renderRichTextLine(
              getMicroCopy({ key: 'text404', data: microCopyData[locale] })
            )}
          >
            <ButtonNew
              variant={BUTTON_VARIANT.PRIMARY}
              size="md"
              url={`/${slugPrefix ? slugPrefix : ''}`}
            >
              {getMicroCopy({ key: 'ctaLabel404', data: microCopyData[locale] })}
            </ButtonNew>
          </Hero>
        </div>
      </section>
    </Layout>
  )
}

export default NotFoundPage
